import { css } from '@genesislcap/web-core';
import { cancelButtonBg, cancelButtonBgHover, labelStyles, closeIconStyles } from '../../../styles';

export const dealDetailStyles = css`
  :host {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .flex-spacer {
    flex: 1;
  }

  .detail-header {
    display: flex;
    width: 100%;
    align-items: center;
    background: var(--black-color);
    padding-top: 10px;

    .detail-header-item {
      flex-shrink: 0;
      padding: 0 20px;
      border-right: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-divider-rest);
    }

    .detail-header-item.description {
      border-right: none;
      padding: 5px;
      max-width: 500px;
    }

    .detail-header-item-description {
      flex-shrink: 0;
      font-size: 14px;
      color: #f1f1f1;
      margin-bottom: 10px;
    }

    .detail-header-item-subline {
      font-size: 12px;
      color: #c9c9c9;
      display: flex;
      gap: 10px;
    }



    .detail-header-item-row {
      margin-bottom: 10px;
      display: flex;
      gap: 5px;
    }

    .detail-header-date-field {
      display: flex;
      gap: 5px;
    }

    .detail-header-badge-field {
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }

  .detail-header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .detail-metadata-toggle {
    border-bottom: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-divider-rest);
    background: var(--black-color);
  }

  .detail-metadata-toggle-button {
    cursor: pointer;
    width: 120px;
    text-align: center;
    background: #1f282d;
    height: 12px;
    box-sizing: border-box;
    border-radius: 4px 4px 0 0;
    border: 1px solid var(--neutral-stroke-divider-rest);
    margin: 0 auto;
    img {
      height: 12px;
      transform: rotate(90deg);
    }
  }

  .detail-metadata-toggle-button.open {
    img {
      transform: rotate(270deg);
    }
  }

  .detail-controls {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    background: #1f282d;
    padding: 0 5px;
    box-sizing: border-box;
    margin-bottom: 10px;

    .detail-controls-item {
      display: flex;
      align-items: center;
      gap: 10px;

      .detail-controls-item-select {
        min-width: 120px;
        max-width: 150px;
        rapid-select {
          min-width: 120px;
          display: block;
        }
      }
    }

    .detail-controls-entry {
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }

  .detail-container {
    flex: 1;
    display: flex;

    .detail-container-empty {
      margin: 20px;
      font-size: 16px;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
    }

    deal-detail-metadata {
      flex: 0;
      min-width: 360px;
    }
  }

  .wire-type-badge {
    --badge-background: rgba(102, 161, 252, 0.4);
    --badge-color: #b2d1ff;
  }

  .detail-header-lead {
    display: flex;
    gap: 10px;

    .detail-header-lead-badge {
      background: #1e272c;
      border: 1px solid ${cancelButtonBg};
      box-sizing: border-box;
      height: 32px;
      width: 32px;
      text-align: center;
      border-radius: 16px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 13px;
      }
    }
  }

  ${labelStyles}

  .submit-modal::part(dialog) {
    max-width: 100%;
    min-width: unset;
    background: #1f2126;
    overflow: hidden;
  }

  .submit-modal::part(content) {
    width: auto;
    max-height: 80vh;
    overflow-y: auto;
  }

  /* Multi-series deal tabs: only the active (visible) panel gets a constrained height.
     Inactive panels carry [hidden] (display:none) so scoping to :not([hidden]) prevents all
     three panels from simultaneously occupying 100% height, which would overflow the page. */
  rapid-tabs[appearance='secondary'] rapid-tab-panel:not([hidden]) {
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  /* Rapid secondary appearance clears tab backgrounds; !important wins over ::slotted. */
  rapid-tabs[appearance='secondary'] rapid-tab {
    height: 40px;
    box-sizing: border-box;
    transition: background-color 0.15s ease, color 0.15s ease;
  }

  rapid-tabs[appearance='secondary'] rapid-tab:not([aria-selected='true']) {
    background-color: #1c2229 !important;
    color: #8f96a0 !important;
  }

  rapid-tabs[appearance='secondary'] rapid-tab:not([aria-selected='true']):hover {
    background-color: #242b34 !important;
    color: var(--neutral-foreground-rest) !important;
  }

  rapid-tabs[appearance='secondary'] rapid-tab[aria-selected='true'] {
    background-color: #323b40 !important;
    color: var(--neutral-foreground-rest) !important;
    font-weight: 600;
    box-shadow: inset 0 -3px 0 0 var(--accent-fill-rest) !important;
  }

  rapid-tabs[appearance='secondary'] rapid-tab:not(:last-of-type) {
    border-right: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-divider-rest);
  }

  .reconfirm-modal-content {
    max-width: 350px;

    p {
      margin-bottom: 20px;
      color: var(--neutral-foreground-rest);
    }
  }

  .reconfirm-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }

  .reconfirm-cancel-button::part(control) {
    background-color: ${cancelButtonBg};
    border: 1px solid ${cancelButtonBg};
    color: white;
  }

  .reconfirm-cancel-button::part(control):hover {
    background-color: ${cancelButtonBgHover};
  }

  ${closeIconStyles}
`;
